<style scoped>
.ivu-table .demo-table-info-row td {
    color: red;
}

.custom-group-switch {
    margin-right: -2px;
    z-index: 10;
    border-radius: 0;
}

.custom-group-switch .ivu-switch-large {
    height: 99%;
    border-radius: 0;
    padding-top: 4px;
    width: 70px;
}

.custom-group-switch .ivu-switch-inner {
    margin-left: 4px;
}

.custom-group-switch .ivu-switch-large:after {
    margin: 4px 0 0 4px;
}

.table-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}
</style>

<template>
    <div>
        <Card>
            <p slot="title"> Klaim List </p>

            <Button :disabled="!isSearchShow" :loading="isPrintClaimList" @on-change="updateFilter" icon="ios-printer-outline" type="success"
              slot="extra" size="small" @click="printClaimList()">
              <span v-if="!isPrintClaimList">Cetak Klaim List </span>
              <span v-else>Sedang diproses.....</span>
            </Button>

            <Row type="flex" justify="space-between" class="code-row-bg">

                <Col span="5">
                <Select v-model="bankAccountId" placeholder="Pilih Rekening Bank" clearable filterable
                    @on-change="updateFilter">
                    <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                        bankAccount.accountName }}</Option>
                </Select>
                </Col>

                <Col span="2">
                <Select v-model="itemDeptId" placeholder="Department" clearable filterable
                    @on-change="updateFilter">
                    <Option v-for="itemDept in itemsDept" :value="itemDept.id" :key="itemDept.id">{{
                        itemDept.value }}</Option>
                </Select>
                </Col>

                <Col span="2">
                <Select v-model="branchSelected" name="branchSelected" placeholder="Branch" clearable filterable
                    @on-change="updateFilter">
                    <Option v-for="type in branchList" :value="type.value" :key="type.value">
                        {{ type.label }}
                    </Option>
                </Select>
                </Col>

                <Col span="2">
                <Select v-model="categoryId" placeholder="Category" clearable filterable
                    @on-change="updateFilter">
                    <Option v-for="category in categories" :value="category.id" :key="category.id">{{
                        category.value }}</Option>
                </Select>
                </Col>

                <Col span="5">
                  <ButtonGroup class="custom-group-parent">
                      <Button class="custom-group">Tgl. Klaim</Button>
                      <Date-picker v-model="dateKlaimSelect" style="width: 220px;" type="daterange" format="yyyy-MM-dd"
                          @on-change="updateFilter">
                      </Date-picker>
                  </ButtonGroup>
                  </Col>

                  <!-- <Col span="4">
                  <ButtonGroup class="custom-group-parent">
                      <Button class="custom-group">Tgl. Mutasi</Button>
                      <Date-picker v-model="dateMutasiSelect" style="width: 180px;" type="daterange" format="yyyy-MM-dd"
                          @on-change="updateFilter">
                      </Date-picker>
                  </ButtonGroup>
                  </Col> -->

                <Col span="5" style="display: flex;">
                  <div class="custom-group-switch">
                      <i-switch size="large" v-model="isGroupFilter">
                          <span slot="open">Group</span>
                          <span slot="close">Mark</span>
                      </i-switch>
                  </div>

                  <transition name="move-right">
                      <Select clearable filterable placeholder="Select Marking" v-show="isGroupFilter == false"
                          v-model="markingIdSelected" :remote-method="getMarkingByCode" :loading="isLoadingMarking"
                          @on-change="updateFilter()">
                          <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                              {{ option.label }}</Option>
                      </Select>
                  </transition>

                  <transition name="move-left">
                      <Select clearable filterable placeholder="Select Group Name" v-show="isGroupFilter == true"
                          v-model="markingGroupIdSelected" :remote-method="getMarkingGroupByCode"
                          :loading="isLoadingMarking" @on-change="updateFilter()">
                          <Option v-for="option in optionMarkingGroups" :value="option.value" :key="option.value">
                              {{ option.label }}</Option>
                      </Select>
                  </transition>
                </Col>

                <Col span="2">
                <Button type="primary" :loading="isLoadingMarking" icon="ios-search" @click="searchClickHandle"
                    v-show="isSearchShow">
                    <span v-if="!isLoadingMarking">Cari</span>
                    <span v-else>Wait.....</span>
                </Button>
                </Col>

                <Col span="2">
                  <Spin size="large" v-show="isLoadingMarking"></Spin>
                </Col>
            </Row>

            <!-- <Alert type="info" show-icon>Claim yang berwarna merah berarti, data tersebut sudah dihapus dari pembayaran</Alert> -->

            <br>

            <Card v-show="isGroupFilter == false">
                <div class="table-container">
                    <Table :row-class-name="rowClassName" border :columns="columnsDataTable" :data="invoiceClaimData"
                        :width="1750"></Table>
                </div>
            </Card>

            <Card v-show="isGroupFilter == true">
                <Table :row-class-name="rowClassName" border :columns="columnsGroupTable" :data="invoiceClaimGroupData">
                </Table>
            </Card>
        </Card>

        <!-- Modal detail -->
        <Modal v-model="isModalDetail" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Detail</span>
            </p>
            <Form ref="formDetail" :model="formDetail">
                <Form-item label="Tanggal & No. Partai">
                    <Input v-model="formDetail.invoiceDateContainerCode" readonly></Input>
                </Form-item>
                <Form-item label="Keterangan">
                    <Input v-model="formDetail.description" readonly></Input>
                </Form-item>
                <FormItem>
                    <Row type="flex" justify="space-between">
                        <Col span="6">
                        Category Claim
                        </Col>
                        <Col span="6">
                        Nilai Klaim
                        </Col>
                        <Col span="6">
                        Keterangan
                        </Col>
                        <Col span="4">
                        Load date
                        </Col>
                    </Row>
                </FormItem>
                <template v-for="(item, index) in formDetail.claimDetail">
                    <FormItem>
                        <Row type="flex" justify="space-between">
                            <Col span="6">
                            <Input
                              :value="formDetail.claimDetail[index].category_claim
                                ? formDetail.claimDetail[index].category_claim.code + '. ' + formDetail.claimDetail[index].category_claim.name
                                : ''"
                              readonly
                            />
                            </Col>
                            <Col span="6">
                            <Money v-if="formDetail.isSpecialMarking"
                                v-model="formDetail.claimDetail[index].claim_value" v-bind="moneySg" class="ivu-input"
                                readonly>
                            </Money>
                            <Money v-else v-model="formDetail.claimDetail[index].claim_value" v-bind="money"
                                class="ivu-input" readonly>
                            </Money>
                            </Col>
                            <Col span="6">
                            <Input v-model="formDetail.claimDetail[index].description" type="textarea"
                                :autosize="{ minRows: 2, maxRows: 5 }" readonly></Input>
                            </Col>
                            <Col span="4">
                            <Input v-model="formDetail.claimDetail[index].load_date" type="date" readonly></Input>
                            </Col>
                        </Row>
                    </FormItem>
                </template>
                <FormItem>
                    <Row>
                        <Col span="12" offset="11">
                        <b>
                            Total Nilai Klaim :
                            <span style="float:right">{{ formDetail.totalClaim }}</span>
                        </b>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        </Modal>

        <!-- Modal detail Group -->
        <Modal v-model="isModalGroupDetail" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Detail Group</span>
            </p>
            <template v-for="(claimGroup, index) in formDetailGroup">

                <Form :ref="'-claimGroup-' + index" :model="claimGroup">

                    <Form-item label="Marking Header Code">
                        <Input v-model="claimGroup.markingHeaderCode" readonly></Input>
                    </Form-item>
                    <Form-item label="Tanggal & No. Partai">
                        <Input v-model="claimGroup.invoiceDateContainerCode" readonly></Input>
                        <Input style="display:none" v-model="claimGroup.markingHeaderId"></Input>
                        <Input style="display:none" v-model="claimGroup.receivableId"></Input>
                    </Form-item>
                    <Form-item label="Keterangan">
                        <Input v-model="claimGroup.description" readonly></Input>
                    </Form-item>
                    <FormItem>
                        <Row type="flex" justify="space-between">
                            <Col span="6">
                            Category Claim
                            </Col>
                            <Col span="6">
                            Nilai Klaim
                            </Col>
                            <Col span="6">
                            Keterangan
                            </Col>
                            <Col span="4">
                            Load date
                            </Col>

                        </Row>
                    </FormItem>
                    <template v-for="(item, index) in claimGroup.claimDetail">
                        <FormItem>
                            <Row type="flex" justify="space-between">
                                <Col span="6">
                                <Input
                                  :value="claimGroup.claimDetail[index].category_claim
                                    ? claimGroup.claimDetail[index].category_claim.code + '. ' + claimGroup.claimDetail[index].category_claim.name
                                    : ''"
                                  readonly
                                />
                                </Col>
                                <Col span="6">
                                <Money v-if="claimGroup.isSpecialMarking" v-model="item.claim_value" v-bind="moneySg"
                                    class="ivu-input" readonly>
                                </Money>
                                <Money v-else v-model="item.claim_value" v-bind="moneySg" class="ivu-input" readonly>
                                </Money>
                                </Col>
                                <Col span="6">
                                <Input v-model="item.description" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"
                                    readonly></Input>
                                </Col>
                                <Col span="4">
                                <Input v-model="item.load_date" type="date" readonly></Input>
                                </Col>
                            </Row>
                        </FormItem>
                    </template>
                    <FormItem>
                        <Row>
                            <Col span="12" offset="11">
                            <b>
                                Total Nilai Klaim :
                                <span style="float:right">{{ claimGroup.totalClaim }}</span>
                            </b>
                            </Col>
                        </Row>
                    </FormItem>
                </Form>
                <hr>
            </template>
            <b>
                Total Nilai Klaim :
                <span style="float:right">{{ claimTotalGroup }}</span>
            </b>
        </Modal>

        <!-- Modal confirm update list -->
        <Modal v-model="isModalConfirm" title="Konfirmasi" ok-text="Ya" cancel-text="Tidak" @on-ok="updateClaimList"
            @on-cancel="cancelUpdateClaimList">
            Silahkan pilih kategori NT yang sesuai:
            <br />
            <br />
            <Select style="display:revert" placeholder="Pilih Kategori NT" v-model="category">
                  <Option v-for="category in categories" :value="category.id" :key="category.id">{{
                      category.value }}
                  </Option>
              </Select>
            <div v-html="confirmationMessage"></div>
        </Modal>

        <!-- Modal confirm approve Group -->
        <Modal v-model="isModalConfirmGroup" title="Konfirmasi Claim Group" ok-text="Ya" cancel-text="Tidak"
            @on-ok="updateClaimListGroup" @on-cancel="cancelUpdateClaimListGroup">
            <p>{{ confirmationMessage }}</p>
        </Modal>

        <!-- Modal upload -->
        <Modal v-model="isModalUploadFile" width="60%" @on-cancel="afterUploadFile">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Upload File</span>
            </p>
            <Form ref="uploadFileForm" :model="formUploadFile">
                <Input style="display: none;" v-model="formUploadFile.claimId"></Input>
                <Input style="display: none;" v-model="formUploadFile.markingHeaderCode"></Input>
                <Form-item prop="file">
                    <div v-show="formUploadFile.imageUploaded.length > 0"
                        style="display: flex; justify-content: center; align-items: center;">
                        <div v-for="(imgUpl) in formUploadFile.imageUploaded">
                            <img :src="imgUpl" alt="Uploaded Image"
                                style="max-width: 100%; max-height: 500px; width: auto; padding: 10px;" />
                        </div>
                    </div>

                    <Upload v-if="isGroupFilter" multiple type="drag" ref="upload" name="fileUploaded"
                        :action="this.serverUrlUploadFile" :before-upload="handleBeforeUpload" accept="image/*">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Upload v-else type="drag" multiple ref="upload" name="fileUploaded" :action="this.serverUrlUploadFile"
                        :before-upload="handleBeforeUpload" accept="image/*">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                </Form-item>
            </Form>

            <div slot="footer">
                <Button type="primary" @click="afterUploadFile">
                    <span>OK</span>
                </Button>
            </div>
        </Modal>

        <!-- Modal edit -->
        <Modal v-model="isModalEdit" width="60%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Edit</span>
            </p>
            <Form ref="formEdit" :model="formEdit">
                <Form-item label="Tanggal - No. Partai & Keterangan">
                    <Input v-model="formEdit.invoiceDateContainerCodeDescription" type="textarea"
                        :autosize="{ minRows: 2, maxRows: 5 }" disabled></Input>
                    <Input style="display:none" v-model="formEdit.claimId"></Input>
                    <Input style="display:none" v-model="formEdit.markingHeaderId"></Input>
                    <Input style="display:none" v-model="formEdit.receivableId"></Input>
                </Form-item>
                <FormItem>
                    <Row type="flex" justify="space-between">
                        <Col span="8">
                        Category Klaim
                        </Col>
                        <Col span="5">
                        Nilai Klaim
                        </Col>
                        <Col span="8">
                        Keterangan
                        </Col>
                        <Col span="2">
                        </Col>
                    </Row>
                </FormItem>
                <template v-for="(item, index) in formEdit.claimDetail">
                    <FormItem v-if="item.formDynamic.items[0].status" :key="index">
                        <Row type="flex" justify="space-between">
                            <Col span="8">
                            <Select
                              v-model="item.formDynamic.items[0].categoryClaimId"
                              placeholder="Select"
                              clearable
                              filterable>
                                <Option
                                    v-for="categoryClaim in categoryClaims"
                                    :value="categoryClaim.id"
                                    :key="categoryClaim.id">  {{ `${categoryClaim.code}. ${categoryClaim.name} ` }}</Option>
                            </Select>
                            </Col>
                            <Col span="5">
                            <Money v-if="formEdit.isSpecialMarking" v-model="item.formDynamic.items[0].claimValue"
                                v-bind="moneySg" class="ivu-input" :disabled="formEdit.isApprove">
                            </Money>
                            <Money v-else v-model="item.formDynamic.items[0].claimValue" v-bind="money"
                                class="ivu-input" :disabled="formEdit.isApprove">
                            </Money>
                            </Col>
                            <Col span="8">
                            <Input v-model="item.formDynamic.items[0].description"></Input>
                            </Col>
                            <Col span="2">
                            <Button @click="handleEditRemove(index)" type="error">Delete</Button>
                            </Col>
                        </Row>
                    </FormItem>
                </template>
                <FormItem>
                    <Row type="flex" justify="space-between">
                        <Col span="7">
                        <Button type="info" @click="handleEditAdd"> + Tambah Nilai Klaim</Button>
                        </Col>
                        <Col span="14">
                        <b>
                            Total Nilai Klaim :
                            <span v-if="formEdit.isSpecialMarking" style="float:right">{{ formEdit.currency }}. {{
                                claimValueTotal | currencyInter }}</span>
                            <span v-else style="float:right">{{ formEdit.currency }}. {{ claimValueTotal | currency
                                }}</span>
                        </b>
                        </Col>
                        <Col span="2">
                        </Col>
                    </Row>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button v-show="true" type="primary" :loading="isLoadingEdit" @click="postEdit">
                    <span v-if="!isLoadingEdit">Simpan</span>
                    <span v-else>Uploading.....</span>
                </Button>
            </div>
        </Modal>

        <!-- Modal edit Group -->
        <Modal v-model="isModalGroupEdit" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Edit Group</span>
            </p>

            <Form :ref="formEditGroup" :model="formEditGroup">
                <template v-for="(claimGroupEdit, i) in formEditGroup.claimLists">
                    <Form-item label="Tanggal - No. Partai & Keterangan">
                        <Input v-model="claimGroupEdit.invoiceDateContainerCodeDescription" type="textarea"
                            :autosize="{ minRows: 2, maxRows: 5 }" disabled></Input>
                        <Input style="display:none" v-model="claimGroupEdit.claimId"></Input>
                        <Input style="display:none" v-model="claimGroupEdit.markingHeaderId"></Input>
                        <Input style="display:none" v-model="claimGroupEdit.receivableId"></Input>
                    </Form-item>
                    <Form-item label="Marking Header Code">
                        <Input v-model="claimGroupEdit.markingHeaderCode" disabled></Input>
                    </Form-item>
                    <FormItem>
                        <Row>
                            <Col span="10">
                            Nilai Klaim
                            </Col>
                            <Col span="12" offset="1">
                            Keterangan Klaim
                            </Col>
                        </Row>

                    </FormItem>
                    <template v-for="(item, index) in claimGroupEdit.claimDetail">
                        <FormItem v-if="item.status" :key="i + '-' + index">
                            <Row>
                                <Col span="8">
                                <Money v-if="claimGroupEdit.isSpecialMarking" v-model="item.claimValue" v-bind="moneySg"
                                    @focusout.native="changeClaimValue()" class="ivu-input">
                                </Money>
                                <Money v-else v-model="item.claimValue" v-bind="money"
                                    @focusout.native="changeClaimValue()" class="ivu-input">
                                </Money>
                                </Col>
                                <Col span="10" offset="1">
                                <Input v-model="item.description"></Input>
                                </Col>
                                <Col span="4" offset="1">
                                <Button @click="handleEditRemoveGroup(index, claimGroupEdit.claimGroupId)"
                                    type="error">Delete</Button>
                                </Col>
                            </Row>
                        </FormItem>
                    </template>
                    <FormItem>
                        <Row>
                            <Col span="8">
                            <Button type="info" @click="handleEditAddGroup(claimGroupEdit.claimGroupId)"> + Tambah Nilai
                                Klaim</Button>
                            </Col>
                            <Col span="10" offset="1">
                            <b>
                                Total Nilai Klaim :
                                <span style="float:right">{{ claimGroupEdit.claimValueTotal }}</span>
                            </b>
                            </Col>
                        </Row>
                    </FormItem>
                </template>
            </Form>

            <div slot="footer">
                <Button v-show="true" type="primary" :loading="isLoadingEdit" @click="postEditGroup">
                    <span v-if="!isLoadingEdit">Simpan</span>
                    <span v-else>Uploading.....</span>
                </Button>
            </div>
        </Modal>

        <!-- Modal delete payment -->
        <Modal v-model="isModalDelete" title="Konfirmasi" ok-text="Ya" cancel-text="Tidak"
            @on-cancel="confirmDescription = ''">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Hapus Klaim</span>
            </p>

            <template>
                <div style="font-weight: bold;">
                    <Row>
                        <Col span="4"> Marking </Col>
                        <Col span="1"> : </Col>
                        <Col span="19"> {{ this.formDeleteClaim.marking }} </Col>
                    </Row>
                    <Row>
                        <Col span="4"> Nominal </Col>
                        <Col span="1"> : </Col>
                        <Col span="19"> {{ this.formDeleteClaim.totalClaim }} </Col>
                    </Row>
                    <Row>
                        <Col span="4"> Keterangan </Col>
                        <Col span="1"> : </Col>
                        <Col span="19"> {{ this.formDeleteClaim.marking }} </Col>
                    </Row>
                </div>
                <hr /><br />
                <i> Ketik <b>{{ formDeleteClaim.marking }}</b> untuk melanjutkan !</i>
                <Input style="display: none" v-model="this.formDeleteClaim.claimId" />
                <Input v-model="confirmDescription" />
            </template>
            <div slot="footer">
                <Button type="error" long
                    v-show="(formDeleteClaim.marking).toUpperCase() == confirmDescription.toUpperCase()"
                    @click="deleteClaim">Hapus</Button>
            </div>
        </Modal>

        <!-- Modal Image -->
        <Modal v-model="isModalImageOss" width="50%" @on-ok="imageUrlFiles = []" @on-cancel="imageUrlFiles = []">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Images</span>
            </p>

            <SliderClaimImages
              v-if="imageUrlFiles.length"
              :key="imageUrlFiles.join()"
              :slides="imageUrlFiles"
            />
            <br>

            <!-- <img v-for="imageUrl in imageUrlFiles" :src="imageUrl" alt="Uploaded Image" :style="{
                transform: `scale(${imageZoomLevel})`,
                transformOrigin: 'center center',
                transition: 'transform 0.2s ease',
                maxWidth: '100%',
                width: 'auto',
                padding: '10px'
            }" /> -->

            <div style="text-align: center; margin-bottom: 10px;">
                <ButtonGroup>
                    <Button type="primary" @click="zoomImage('in')">
                        <Icon type="md-add"></Icon> Zoom In
                    </Button>
                    <Button type="primary" @click="zoomImage('out')">
                        <Icon type="md-remove"></Icon> Zoom Out
                    </Button>
                    <Button type="default" @click="zoomImage('reset')">
                        <Icon type="md-refresh"></Icon> Reset Zoom
                    </Button>
                </ButtonGroup>
            </div>
        </Modal>

        <Modal v-model="isModalImage" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Image</span>
            </p>
            <img :src="imageUrl" alt="Uploaded Image" :style="{
                transform: `scale(${imageZoomLevel})`,
                transformOrigin: 'center center',
                transition: 'transform 0.2s ease',
                maxWidth: '100%',
                width: 'auto',
                padding: '10px'
            }" />
            <div style="text-align: center; margin-bottom: 10px;">
                <ButtonGroup>
                    <Button type="primary" @click="zoomImage('in')">
                        <Icon type="md-add"></Icon> Zoom In
                    </Button>
                    <Button type="primary" @click="zoomImage('out')">
                        <Icon type="md-remove"></Icon> Zoom Out
                    </Button>
                    <Button type="default" @click="zoomImage('reset')">
                        <Icon type="md-refresh"></Icon> Reset Zoom
                    </Button>
                </ButtonGroup>
            </div>
        </Modal>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import { constant } from 'lodash';
import moment from 'moment'
import { list, parse } from 'postcss';
import { Money } from 'v-money'
import SliderClaimImages from './SliderClaimImages.vue';

const numeral = require('numeral');
let serverIP = localStorage.getItem('serverIP')

export default {
    components: { Money, SliderClaimImages },
    data() {
        return {
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            moneySg: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            isModalDelete: false,
            formDeleteClaim: {
                claimId: null,
                totalClaim: 0,
                marking: ''
            },
            confirmDescription: '',
            markingIdSelected: '',
            markingGroupIdSelected: '',
            isSearchShow: false,
            optionMarkings: [],
            isLoadingMarking: false,
            branchSelected: '',
            branchList: [],
            userRole: localStorage.getItem('user.role'),
            categories: [
              {
                  id : 'MUTASI',
                  value : 'MUTASI'
              },
              {
                  id : 'PENYESUAIAN',
                  value : 'PENYESUAIAN'
              }
            ],
            category: "PENYESUAIAN",
            columnsDataTable: [
                {
                    title: 'Marking',
                    key: 'markingHeaderCode'
                },
                {
                    title: 'Nomor Klaim',
                    key: 'claim_number'
                },
                {
                    title: 'Tanggal Klaim',
                    key: 'claim_date'
                },
                {
                    title: 'Tanggal Invoice',
                    key: 'invoiceDate'
                },
                {
                    title: 'Bank Account Name',
                    key: 'accountName',
                },
                {
                    title: 'No. Container',
                    key: 'containerNumber'
                },
                {
                    title: 'Keterangan',
                    key: 'description'
                },
                {
                    title: 'Total Nilai Klaim',
                    key: 'total_claim'
                },
                {
                    title: 'File',
                    key: 'file',
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params

                        return h('div', [
                            h('a', {
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        // this.downloadFile(row.markingHeaderCode, row.file)
                                        let prefixFile = row.file.split('-')[0]
                                        if (prefixFile == 'CLAIM') {
                                            this.showImage(row)
                                        } else if (prefixFile == 'CLAIMS') {
                                            this.getUrlFile(row)
                                        }
                                    }
                                }
                            }, row.file)
                        ]);
                    }
                },
                {
                    title: 'Kategori',
                    key: 'category',
                    align: 'center',
                },
                {
                    title: 'Setujui',
                    key: 'isApprove',
                    width: 80,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let setVal = row.isApprove == 1 ? true : false
                        let setDisable = !row.file || setVal ? true : false

                        return h('Checkbox', {
                            props: {
                                value: setVal,
                                checked: setVal,
                                disabled: setDisable
                            },
                            on: {
                                'on-change': (isApprove) => {
                                    this.showModalConfirm('isApprove', isApprove, params.index)
                                }
                            }
                        });
                    }
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 300,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        // let isEditDisabled = row.file ? true : false;
                        let isEditDisabled = row.isApprove == 1 ? true : false;
                        let isDeleteDisabled = row.isApprove == 1 ? true : false;

                        if(this.userRole == 'ADMINISTRATOR'){
                            isEditDisabled = false;
                        }

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalDetail(params.index)
                                    }
                                }
                            }, 'Detail'),
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.getXlsFromStorage(params.index)
                                    }
                                }
                            }, 'Excel'),
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalUpload(params.index)
                                    }
                                }
                            }, 'Upload'),
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: isEditDisabled
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalEdit(params.index)
                                    }
                                }
                            }, 'Edit'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: isDeleteDisabled
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalDelete(params.index)
                                    }
                                }
                            }, 'Hapus'),
                            // h('Button', {
                            //     props: {
                            //         type: 'success',
                            //         size: 'small'
                            //     },
                            //     on: {
                            //         click: () => {
                            //             console.log({row});
                            //             this.$router.push({
                            //                 name: 'claimPaymentAdd',
                            //                 params: {
                            //                     paymentClaimId : row.claimId,
                            //                     paymentDateProp : null,
                            //                     paymentClaimAmount : parseInt(row.total_claim.replace(/\D/g, "")),
                            //                     paymentClaimMarking : row.markingHeaderCode
                            //                 }
                            //             });
                            //         }
                            //     }
                            // }, 'Pembayaran'),
                        ]);
                    }
                },
            ],
            columnsGroupTable: [
                {
                    title: 'Marking group',
                    key: 'markingGroupCode'
                },
                {
                    title: 'Nomor Klaim',
                    key: 'claim_number'
                },
                {
                    title: 'Tanggal Klaim',
                    key: 'claim_date'
                },
                {
                    title: 'Keterangan',
                    key: 'description'
                },
                {
                    title: 'Total Nilai Klaim',
                    key: 'total_claim'
                },
                {
                    title: 'File',
                    key: 'file',
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        const batchString = (row.file != null && row.file != '') ? 'CLAIMS-' + row.markingGroupCode + '-[BATCH]' : '';

                        return h('div', [
                            h('a', {
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        let prefixFile = row.file.split('-')[0]
                                        if (prefixFile == 'CLAIM') {
                                            this.showImage(row)
                                        } else if (prefixFile == 'CLAIMS') {
                                            this.getUrlFile(row)
                                        }
                                    }
                                }
                            }, batchString)
                        ]);
                    }
                },
                 {
                    title: 'Kategori',
                    key: 'category',
                    align: 'center',
                },
                {
                    title: 'Setujui',
                    key: 'isApprove',
                    width: 80,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let setVal = row.isApprove == 1 ? true : false
                        let setDisable = !row.file || setVal ? true : false

                        return h('Checkbox', {
                            props: {
                                value: setVal,
                                checked: setVal,
                                disabled: setDisable
                            },
                            on: {
                                'on-change': (isApprove) => {
                                    this.showModalConfirmGroup('isApprove', isApprove, params.index)
                                }
                            }
                        });
                    }
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 300,
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params
                        let isEditDisabled = row.file ? true : false;
                        let isDeleteDisabled = row.isApprove == 1 ? true : false;

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'warning',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalGroupDetail(params.index)
                                    }
                                }
                            }, 'Detail'),
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.getXlsGroupFromStorage(params.index)
                                    }
                                }
                            }, 'Excel'),
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalUploadGroup(params.index)
                                    }
                                }
                            }, 'Upload'),
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: isEditDisabled
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalEditGroup(params.index)
                                    }
                                }
                            }, 'Edit'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: isDeleteDisabled
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalDeleteGroup(params.index)
                                    }
                                }
                            }, 'Hapus'),
                        ]);
                    }
                },
            ],
            dateMutasiSelect: [],
            dateKlaimSelect: [],
            invoiceClaimData: [],
            invoiceClaimGroupData: [],
            isModalDetail: false,
            isModalGroupDetail: false,
            isModalConfirm: false,
            isModalConfirmGroup: false,
            confirmationMessage: null,
            formDetail: {},
            formDetailGroup: {},
            bankAccountId: null,
            itemDeptId: null,
            categoryId: null,
            bankAccounts: [],
            itemsDept: [
                {
                    id : 'FCL',
                    value : 'FCL'
                },
                {
                    id : 'LCL',
                    value : 'LCL'
                },
                {
                    id : 'UDARA',
                    value : 'UDARA'
                }
            ],
            categories: [
                {
                    id : 'MUTASI',
                    value : 'MUTASI'
                },
                {
                    id : 'PENYESUAIAN',
                    value : 'PENYESUAIAN'
                }
            ],
            isModalUploadFile: false,
            formUploadFile: {
                claimId: null,
                markingHeaderCode: null,
                fileName: null,
                imageUploaded: [],
            },
            isLoadingUploadFile: false,
            serverUrlUploadFile: '',
            isProgress: false,
            pValue: 0,
            isModalEdit: false,
            isModalGroupEdit: false,
            isLoadingEdit: false,
            formEdit: {
                claimDetail: []
            },
            formEditGroup: {
                claimId: 0,
                claimLists: []
            },
            isGroupFilter: false,
            optionMarkingGroups: [],
            markingGroupSelect: {},
            claimTotalGroup: 0,
            isModalImage: false,
            isModalImageOss: false,
            imageUrl: '',
            imageUrlFiles: [],
            imageZoomLevel: 1,
            isPrintClaimList: false,
            categoryClaims: [],
        }
    },
    methods: {
        rowClassName(row, index) {
            if (row.isDeleted) {
                return 'demo-table-info-row';
            }

            return '';
        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getMarkingByCode: _.debounce(
            function (query) {
                query = query.trim();
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query
                        })
                        .then(response => {
                            this.isLoadingMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.isLoadingMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        getMarkingGroupByCode: _.debounce(
            function (query) {
                query = query.trim();
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                        .post('markingGroup/getByCode', {
                            groupName: query
                        })
                        .then(response => {
                            this.isLoadingMarking = false;
                            let data = response.data;

                            const list = data.map(item => {

                                return {
                                    value: item.id,
                                    label: item.code,
                                    detail: item.detail
                                };
                            });

                            this.optionMarkingGroups = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.isLoadingMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkingGroups = [];
                }
            }, 400
        ),
        searchClickHandle: function () {
            const isGroupFilter = this.isGroupFilter
            console.info(isGroupFilter);
            if (isGroupFilter == true) { // jika group filternya true
                this.getClaimMarkingGroup()
            } else {
                this.getClaimMarking()
            }
        },
        getClaimMarking: function () {

            let startDateKlaim = null;
            let endDateKlaim = null;
            let startDateMutasi = null;
            let endDateMutasi = null;
            let markingIdSelected = null
            let bankAccountId = null
            let itemDeptId = null
            let branch = null
            let categoryId = null

            if (this.markingIdSelected != "") {
                markingIdSelected = this.markingIdSelected
            }

            if (this.dateKlaimSelect[0] != "" && this.dateKlaimSelect[0] != null) {
                startDateKlaim = moment(this.dateKlaimSelect[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endDateKlaim = moment(this.dateKlaimSelect[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            if (this.dateMutasiSelect[0] != "" && this.dateMutasiSelect[0] != null) {
                startDateMutasi = moment(this.dateMutasiSelect[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endDateMutasi = moment(this.dateMutasiSelect[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            if (this.bankAccountId != "") {
                bankAccountId = this.bankAccountId
            }

            if (this.itemDeptId != "") {
                itemDeptId = this.itemDeptId
            }

            if (this.branchSelected != "") {
                branch = this.branchSelected
            }

            if (this.categoryId != "") {
                categoryId = this.categoryId
            }

            let parent = this;
            let payload = {
                markingHeaderId: markingIdSelected,
                startClaimDate: startDateKlaim,
                endClaimDate: endDateKlaim,
                startInvoiceDate: startDateMutasi,
                endInvoiceDate: endDateMutasi,
                bankAccountId: bankAccountId,
                itemDeptId: itemDeptId,
                branch: branch,
                categoryId: categoryId
            }

            this.invoiceClaimData = [];
            this.isLoadingMarking = true;
            HTTP.post('claim/search', payload)
                .then(response => {
                    let invoiceClaim = []
                    _.forEach(response.data, function (value, index) {
                        let currency = 'Rp';
                        let isSpecialMarking = false
                        let markingheadercode = value.marking_header.markingheadercode
                        let prefixMarking = markingheadercode.split('/')[0]
                        if (prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH') {
                            isSpecialMarking = true

                            let currency = value.receivable.invoice != null ? value.receivable.invoice.currency : ''
                             if (currency != 'SGD' && currency != 'BAHT') {
                                currency = 'Rp'
                             }
                        }

                        let total_claim = 0
                        if (isSpecialMarking) {
                            total_claim = value.total_claim != null ? currency + ". " + numeral(value.total_claim).format('0,0.00') : '';
                        } else {
                            total_claim = value.total_claim != null ? currency + ". " + numeral(value.total_claim).format('0,0') : '';
                        }

                        let invoiceDate = value.receivable.invoice != null ? parent.showDateFormatted(value.receivable.invoice.invoicedate) : ''

                        var containerNumber = '-'
                        var containerCode = ''
                        var invoicefee = value.receivable.debitAmount

                        if (value.receivable.invoice != null) {
                            invoiceDate = value.receivable.invoice != null ? parent.showDateFormatted(value.receivable.invoice.invoicedate) : ''
                            containerNumber = value.receivable.invoice.packaging_list.container_loading != null ? value.receivable.invoice.packaging_list.container_loading.containernumber : ''
                            containerCode = value.receivable.invoice.packaging_list.container_loading != null ? value.receivable.invoice.packaging_list.container_loading.containercode : ''
                            invoicefee = value.receivable != null ? value.receivable.invoice.invoicefee : ''
                        } else {
                            invoiceDate = parent.showDateFormatted(value.receivable.transactionDate)
                            containerNumber = '-'
                            containerCode = ''
                            invoicefee = value.receivable.debitAmount
                        }

                        let invoiceDueId = value.invoice_due != null ? value.invoice_due.id : ''
                        let receivableRemaining = value.invoice_due != null ? value.invoice_due.receivableRemaining : ''

                        let accountName = value.bank_account != null ? value.bank_account.accountName : '-'

                        let claimDetail = value.claim_detail.map((claim) => {
                            return {
                                ...claim,
                                claim_value: parseFloat(claim.claim_value)
                            }
                        })

                        let iClaim = {
                            claimId: value.id,
                            receivableId: value.receivableid,
                            markingHeaderId: value.markingheaderid,
                            markingHeaderCode: markingheadercode,
                            invoiceDate: invoiceDate,
                            claim_date: value.claim_date != null ? parent.showDateFormatted(value.claim_date) : '',
                            claim_number: value.claim_number,
                            containerNumber: containerNumber,
                            containerCode: containerCode,
                            total_claim: total_claim,
                            description: value.receivable.description,
                            file: value.filename,
                            claim_detail: claimDetail,
                            isApprove: value.isApprove,
                            invoiceFee: invoicefee,
                            invoiceDueId: invoiceDueId,
                            receivableRemaining: receivableRemaining,
                            accountName: accountName,
                            isSpecialMarking: isSpecialMarking,
                            currency: currency,
                            categoryId: value.categoryCodeId,
                            category: value.category
                        }
                        invoiceClaim.push(iClaim);

                    });

                    this.invoiceClaimData = invoiceClaim;
                    this.isLoadingMarking = false;
                })
                .catch(e => {
                    this.isLoadingMarking = false;

                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getClaimMarkingGroup: function () {
            let startDateKlaim = null;
            let endDateKlaim = null;
            let startDateMutasi = null;
            let endDateMutasi = null;
            let markingGroupIdSelected = null
            let bankAccountId = null
            let itemDeptId = null

            if (this.markingGroupIdSelected != "") {
                markingGroupIdSelected = this.markingGroupIdSelected
            }

            if (this.dateKlaimSelect[0] != "" && this.dateKlaimSelect[0] != null) {
                startDateKlaim = moment(this.dateKlaimSelect[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endDateKlaim = moment(this.dateKlaimSelect[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            if (this.dateMutasiSelect[0] != "" && this.dateMutasiSelect[0] != null) {
                startDateMutasi = moment(this.dateMutasiSelect[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endDateMutasi = moment(this.dateMutasiSelect[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            if (this.bankAccountId != "") {
                bankAccountId = this.bankAccountId
            }

            if (this.itemDeptId != "") {
                itemDeptId = this.itemDeptId
            }

            let parent = this;
            let payload = {
                markingGroupId: markingGroupIdSelected,
                startClaimDate: startDateKlaim,
                endClaimDate: endDateKlaim,
                startInvoiceDate: startDateMutasi,
                endInvoiceDate: endDateMutasi,
                bankAccountId: bankAccountId,
                itemDeptId: itemDeptId,
            }

            this.invoiceClaimGroupData = [];
            this.isLoadingMarking = true;
            HTTP.post('claimGroup/search', payload)
                .then(response => {
                    let invoiceClaim = []
                    _.forEach(response.data, function (groupClaim, index) {

                        let currency = groupClaim.list_claim_group[0].receivable.invoice != null ? groupClaim.list_claim_group[0].receivable.invoice.currency : ''
                        if (currency != 'SGD' && currency != 'BAHT') {
                            currency = 'Rp'
                        }
                        let claimDateGroup = groupClaim.claim_date != null ? parent.showDateFormatted(groupClaim.claim_date) : '';
                        let totalClaimGroup = groupClaim.total_claim != null ? currency + ". " + numeral(groupClaim.total_claim).format('0,0.00') : '';
                        let totalInvoiceFee = 0;

                        let markingGroupCode = groupClaim.marking_group.code
                        let prefixMarkingGroup = markingGroupCode.split('/')[0]
                        let isSpecialMarkingGroup = false
                        if (prefixMarkingGroup == 'SBR' || prefixMarkingGroup == 'SBRT' || prefixMarkingGroup == 'CTH') {
                            isSpecialMarkingGroup = true
                        }

                        let listClaim = []
                        groupClaim.list_claim_group.forEach((claim) => {
                            let currency = claim.receivable.invoice != null ? claim.receivable.invoice.currency : ''
                            if (currency != 'SGD' && currency != 'BAHT') {
                                currency = 'Rp'
                            }

                            let total_claim = claim.total_claim != null ? currency + ". " + numeral(claim.total_claim).format('0,0.00') : '';
                            let invoiceDate = claim.receivable.invoice != null ? parent.showDateFormatted(claim.receivable.invoice.invoicedate) : ''

                            var containerNumber = '-'
                            var containerCode = ''
                            var invoicefee = claim.receivable.debitAmount

                            if (claim.receivable.invoice != null) {
                                invoiceDate = claim.receivable.invoice != null ? parent.showDateFormatted(claim.receivable.invoice.invoicedate) : ''
                                containerNumber = claim.receivable.invoice.packaging_list.container_loading != null ? claim.receivable.invoice.packaging_list.container_loading.containernumber : ''
                                containerCode = claim.receivable.invoice.packaging_list.container_loading != null ? claim.receivable.invoice.packaging_list.container_loading.containercode : ''
                                invoicefee = claim.receivable != null ? claim.receivable.invoice.invoicefee : ''
                            } else {
                                invoiceDate = parent.showDateFormatted(claim.receivable.transactionDate)
                                containerNumber = '-'
                                containerCode = ''
                                invoicefee = claim.receivable.debitAmount
                            }

                            let invoiceDueId = claim.invoice_due != null ? claim.invoice_due.id : ''
                            let receivableRemaining = claim.invoice_due != null ? claim.invoice_due.receivableRemaining : ''

                            let markingheadercode = claim.marking_header.markingheadercode
                            let prefixMarking = markingheadercode.split('/')[0]
                            let isSpecialMarking = false
                            if (prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH') {
                                isSpecialMarking = true
                            }
                            let claimGroupDetail = claim.claim_group_detail
                                .map((claim) => {
                                    return {
                                        ...claim,
                                        claim_value: parseFloat(claim.claim_value)
                                    }
                                })

                            let claimDetail = {
                                claimId: claim.id,
                                receivableId: claim.receivableid,
                                markingHeaderId: claim.markingheaderid,
                                markingHeaderCode: markingheadercode,
                                invoiceDate: invoiceDate,
                                claim_date: claim.claim_date != null ? parent.showDateFormatted(claim.claim_date) : '',
                                claim_number: claim.claim_number,
                                containerNumber: containerNumber,
                                containerCode: containerCode,
                                total_claim: total_claim,
                                description: claim.receivable.description,
                                file: claim.filename,
                                claim_detail: claimGroupDetail,
                                isApprove: claim.isApprove,
                                invoiceFee: invoicefee,
                                invoiceDueId: invoiceDueId,
                                receivableRemaining: receivableRemaining,
                                currency: currency,
                                isSpecialMarking: isSpecialMarking,
                            }
                            listClaim.push(claimDetail)
                            totalInvoiceFee += invoicefee
                        })

                        let iClaim = {
                            claimId: groupClaim.id,
                            markingGroupId: groupClaim.markingGroupId,
                            markingGroupCode: groupClaim.marking_group.code,
                            claim_date: claimDateGroup,
                            claim_number: groupClaim.claim_number,
                            total_claim: totalClaimGroup,
                            description: groupClaim.description,
                            file: groupClaim.filename,
                            isApprove: groupClaim.isApprove,
                            invoiceFee: totalInvoiceFee,
                            isSpecialMarkingGroup: isSpecialMarkingGroup,
                            claimListGroup: listClaim
                        }
                        invoiceClaim.push(iClaim);
                    });

                    this.invoiceClaimGroupData = invoiceClaim;
                    this.isLoadingMarking = false;
                })
                .catch(e => {
                    this.isLoadingMarking = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        downloadFile: function (markingHeaderCode, fileName) {
            const multipleFile = fileName.split("~");

            multipleFile.forEach(filename => {

                if (filename == null || filename == '') {
                    return
                }

                let payload = {
                    markingHeaderCode: markingHeaderCode,
                    filename: filename
                }

                HTTP
                    .post('claim/file/download', payload, { responseType: 'blob' })
                    .then(response => {
                        // window.open(URL.createObjectURL(response.data));

                        let a = document.createElement("a");
                        let url = window.URL.createObjectURL(response.data);

                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = url;
                        a.download = filename;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
            });
        },
        getXlsFromStorage: function (index) {
            let claimId = this.invoiceClaimData[index].claimId;
            let url = 'https://' + serverIP + 'claim/excel/' + claimId;
            window.open(url, '_blank');
        },
        getXlsGroupFromStorage: function (index) {
            let claimId = this.invoiceClaimGroupData[index].claimId;
            let url = 'https://' + serverIP + 'claimGroup/excel/' + claimId;
            window.open(url, '_blank');
        },
        showModalDetail: function (index) {
            var receivableId = this.invoiceClaimData[index].receivableId;
            var markingHeaderId = this.invoiceClaimData[index].markingHeaderId;
            var markingHeaderCode = this.invoiceClaimData[index].markingHeaderCode;
            var fileName = this.invoiceClaimData[index].fileName;
            var invoiceDate = this.invoiceClaimData[index].invoiceDate;
            var containerNumber = this.invoiceClaimData[index].containerNumber;
            var containerCode = this.invoiceClaimData[index].containerCode;
            var totalClaim = this.invoiceClaimData[index].total_claim;
            var description = this.invoiceClaimData[index].description;
            var claimDetail = this.invoiceClaimData[index].claim_detail;
            let isSpecialMarking = this.invoiceClaimData[index].isSpecialMarking
            let currency = this.invoiceClaimData[index].currency

            this.formDetail.receivableId = receivableId;
            this.formDetail.markingHeaderId = markingHeaderId;
            this.formDetail.markingHeaderCode = markingHeaderCode;
            this.formDetail.fileName = fileName;
            this.formDetail.invoiceDateContainerCode = invoiceDate + ' - P. ' + containerCode;
            this.formDetail.totalClaim = totalClaim;
            this.formDetail.description = description;
            this.formDetail.claimDetail = claimDetail;
            this.formDetail.isSpecialMarking = isSpecialMarking
            this.formDetail.currency = currency;

            this.isModalDetail = true;
        },
        showModalGroupDetail: function (index) {
            let claimShow = []
            let groupTotalClaim = 0
            console.info('showModalGroupDetail', this.invoiceClaimGroupData[index]);
            this.invoiceClaimGroupData[index].claimListGroup.forEach((claim) => {

                var receivableId = claim.receivableId;
                var markingHeaderId = claim.markingHeaderId;
                var markingHeaderCode = claim.markingHeaderCode;
                var fileName = claim.fileName;
                var invoiceDate = claim.invoiceDate;
                var containerNumber = claim.containerNumber;
                var containerCode = claim.containerCode;
                var totalClaim = claim.total_claim;
                var description = claim.description;
                var claimDetail = claim.claim_detail;
                var total_claim = 0;

                claimDetail.forEach(value => {
                    total_claim += parseFloat(value.claim_value)
                })

                let claimObj = {
                    receivableId: receivableId,
                    markingHeaderId: markingHeaderId,
                    markingHeaderCode: markingHeaderCode,
                    fileName: fileName,
                    invoiceDateContainerCode: invoiceDate + ' - P. ' + containerCode,
                    totalClaim: totalClaim,
                    description: description,
                    claimDetail: claimDetail,
                    containerNumber: containerNumber,
                    total_claim: total_claim,
                    currency: claim.currency,
                    isSpecialMarking: claim.isSpecialMarking,
                }

                claimShow.push(claimObj)
                groupTotalClaim += total_claim
            })
            console.info('claimShow', claimShow);
            this.formDetailGroup = claimShow
            this.isModalGroupDetail = true;
            this.claimTotalGroup = groupTotalClaim != null ? "Rp. " + numeral(groupTotalClaim).format('0,0.00') : ''
        },
        showModalConfirm: function (type, value, index) {

            this.isModalConfirm = true
            this.varType = type
            this.varValue = value
            this.varIndex = index

            if (type == 'isApprove') {
              this.confirmationMessage = `

                  <br>
                  <p><strong>Catatan:</strong></p>
                  <p style="color: red;">
                      Pastikan kategori klaim sudah sesuai sebelum menyetujui klaim ini.
                      <br/>
                      Jika.
                  </p>
              `;
            } else {
                return false
            }
        },
        showModalConfirmGroup: function (type, value, index) {

            this.isModalConfirmGroup = true
            this.varType = type
            this.varValue = value
            this.varIndex = index

            if (type == 'isApprove') {
                this.confirmationMessage = 'Apakah anda yakin ingin menyetujui klaim Group ini ?'
            } else {
                return false
            }
        },
        updateClaimList: function () {
            this.$Loading.start();

            let rowData = this.invoiceClaimData[this.varIndex]
            let tempIsApprove = ''
            let successMsg = ''

            let currentDate = moment().toString()
            let transactionDate = moment(currentDate).format('YYYY/MM/DD')

            if (rowData.claim_date != null) {
                transactionDate = moment(rowData.claim_date).format('YYYY/MM/DD')
            }

            let total_claim = 0;
            rowData.claim_detail.forEach(value => {
                total_claim += parseFloat(value.claim_value)
            })

            let paymentAllocate = [{
                invoicefee: rowData.invoiceFee,
                invoiceDueId: rowData.invoiceDueId,
                allocateAmount: total_claim,
                receivableRemaining: rowData.receivableRemaining,
                useDepositAmount: 0,
            }]

            let payloadPayment = {
                markingHeaderId: rowData.markingHeaderId,
                amount: total_claim,
                transactionDate: transactionDate,
                description: 'KLAIM ' + rowData.description,
                depositAmount: 0,
                receivableId: rowData.receivableId,
                paymentAllocates: paymentAllocate,
                depositType: '',
                category: 'disc',
                paymentClaimId: rowData.claimId,
                categoryNT : this.category,
                categoryId: rowData.categoryId
            }

            if (this.varType == 'isApprove') {
                tempIsApprove = true
                successMsg = "Klaim berhasil disetujui"
            }

            let payloadStatus = {
                claimId: rowData.claimId,
                isApprove: tempIsApprove
            }

            ////////// payment as claim //////////
            HTTP
                .post('payment/payClaim', payloadPayment)
                .then(response => {

                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Pembayaran Berhasil',
                        duration: 5
                    });

                    this.getClaimMarking();

                    // ////////// update status //////////
                    // if (response.data.code) {
                    //     HTTP
                    //         .post('claim/status', payloadStatus)
                    //         .then(response => {

                    //             this.isModalConfirm = false;
                    //             this.$Loading.finish();
                    //             this.$Message.success(successMsg);

                    //             if (this.markingIdSelected != '') {
                    //                 this.getClaimMarking()
                    //             }

                    //         })
                    //         .catch(e => {
                    //             this.$Notice.error({
                    //                 title: "Error",
                    //                 desc: e,
                    //                 duration: 5
                    //             });
                    //         })
                    // }
                }).catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        updateClaimListGroup: function () {
            let rowData = this.invoiceClaimGroupData[this.varIndex];
            let currentDate = moment().toString();
            let transactionDate = moment(currentDate).format('YYYY/MM/DD');
            let isSuccess = false;
            let allSuccess = true;
            let error = '';

            let updateClaimStatus = () => {
                if (allSuccess) {
                    let payloadStatus = {
                        claimId: rowData.claimId,
                        isApprove: true
                    };

                    return HTTP.post('claim/status', payloadStatus)
                        .then(response => {

                            this.isModalConfirm = false;
                            this.$Loading.finish();
                            this.$Message.success("Klaim berhasil disetujui");

                            if (this.markingGroupIdSelected != '') {
                                this.getClaimMarkingGroup();
                            }
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        });
                }
            };

            let handleError = (e) => {
                allSuccess = false;
                error = e.message;
            };

            let promises = rowData.claimListGroup.map(claim => {
                if (claim.claim_date != null) {
                    transactionDate = moment(claim.claim_date).format('YYYY/MM/DD');
                }

                let total_claim = 0;
                claim.claim_detail.forEach(value => {
                    total_claim += parseFloat(value.claim_value);
                });

                let paymentAllocate = [{
                    invoicefee: claim.invoiceFee,
                    invoiceDueId: claim.invoiceDueId,
                    allocateAmount: total_claim,
                    receivableRemaining: claim.receivableRemaining,
                    useDepositAmount: 0,
                }];

                let payloadPayment = {
                    markingGroupId: rowData.markingGroupId,
                    paymentClaimId: rowData.claimId,
                    claimGroupId: claim.claimId,
                    markingHeaderId: claim.markingHeaderId,
                    amount: total_claim,
                    transactionDate: transactionDate,
                    description: 'KLAIM ' + claim.description,
                    depositAmount: 0,
                    receivableId: claim.receivableId,
                    paymentAllocates: paymentAllocate,
                    depositType: '',
                    category: 'disc',
                };

                return HTTP.post('payment/payClaim', payloadPayment)
                    .then(response => {
                        isSuccess = true;
                    })
                    .catch(handleError);
            });

            Promise.all(promises).then(() => {
                if (allSuccess) {
                    updateClaimStatus();
                }

                if (isSuccess) {

                    this.loadingPost = false;
                } else {
                    this.loadingPost = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: error,
                        duration: 5
                    });
                }
            });
        },
        cancelUpdateClaimList: function () {
            if (this.markingIdSelected != '') {
                this.getClaimMarking()
            }
        },
        cancelUpdateClaimListGroup: function () {
            if (this.markingIdSelected != '') {
                this.getClaimMarking()
            }
        },
        deleteClaim: function () {
            this.$Loading.start();

            let payload = {
                claimId: this.formDeleteClaim.claimId,
            }

            HTTP
                .post('claim/delete', payload)
                .then(response => {

                    if (response.data.data == true) {
                        this.isModalDelete = false;
                        this.$Loading.finish();
                        this.$Message.success('Claim berhasil dihapus !');
                    } else {
                        this.isModalDelete = false;
                        this.$Loading.finish();
                        this.$Message.error('Claim gagal dihapus !');
                    }

                    if (this.markingIdSelected != '') {
                        this.getClaimMarking()
                    }
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showModalUpload: function (index) {

            let claimId = this.invoiceClaimData[index].claimId;
            let markingHeaderCode = this.invoiceClaimData[index].markingHeaderCode;

            this.formUploadFile.claimId = claimId;
            this.formUploadFile.markingHeaderCode = markingHeaderCode;

            this.isModalUploadFile = true;
        },
        showModalUploadGroup: function (index) {
            let claimGroup = this.invoiceClaimGroupData[index]

            this.formUploadFile.claimId = claimGroup.claimId;
            this.formUploadFile.markingHeaderCode = claimGroup.markingGroupCode;

            this.isModalUploadFile = true;
        },
        showModalDelete: function (index) {
            let rowData = this.invoiceClaimData[index];

            this.formDeleteClaim.claimId = rowData.claimId;
            this.formDeleteClaim.totalClaim = rowData.total_claim;
            this.formDeleteClaim.marking = rowData.markingHeaderCode;

            this.isModalDelete = true;
        },
        showModalDeleteGroup: function (index) {
            let rowData = this.invoiceClaimGroupData[index];

            this.formDeleteClaim.claimId = rowData.claimId;
            this.formDeleteClaim.totalClaim = rowData.total_claim;
            this.formDeleteClaim.marking = rowData.markingGroupCode;

            this.isModalDelete = true;
        },
        handleEditAdd() {
            this.formEdit.claimDetail.push({
                index: this.formEdit.claimDetail.index++,
                formDynamic: {
                    items: [
                        {
                            index: this.formEdit.claimDetail.index++,
                            status: 1,
                            claimValue: '',
                            description: ''
                        }
                    ]
                },
            });
        },
        handleEditAddGroup(claimGroupId) {
            this.formEditGroup.claimLists.forEach(element => {
                if (element.claimGroupId == claimGroupId) {
                    element.claimDetail.push({
                        index: this.formEdit.claimDetail.index++,
                        status: 1,
                        claimValue: '',
                        description: ''
                    })
                }
            })
        },
        handleEditRemove(index) {
            this.formEdit.claimDetail[index].formDynamic.items[0].status = 0;
            this.formEdit.claimValueTotal - this.formEdit.claimDetail[index].formDynamic.items[0].claimValue;
        },
        handleEditRemoveGroup(index, claimGroupId) {
            this.formEditGroup.claimLists.map((value) => {
                if (value.claimGroupId === claimGroupId) {
                    if (index >= 0 && index < value.claimDetail.length) {
                        value.claimDetail.splice(index, 1);
                    }
                }
            })
            this.changeClaimValue()
        },
        showModalEdit: function (index) {
            let parent = this;
            let rowData = this.invoiceClaimData[index];

            this.formEdit.claimId = rowData.claimId;
            this.formEdit.isApprove = rowData.isApprove;
            this.formEdit.receivableId = rowData.receivableId;
            this.formEdit.markingHeaderId = rowData.markingHeaderId;
            this.formEdit.markingHeaderCode = rowData.markingHeaderCode;
            this.formEdit.fileName = rowData.fileName;
            this.formEdit.invoiceDateContainerCodeDescription = rowData.invoiceDate
                + ' - P. ' + rowData.containerCode
                + '\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n'
                + rowData.description;
            this.formEdit.claimValueTotal = rowData.total_claim;
            this.formEdit.isSpecialMarking = rowData.isSpecialMarking
            this.formEdit.currency = rowData.currency
            this.formEdit.claimDetail = [];

            _.forEach(rowData.claim_detail, function (value, index) {
                parent.formEdit.claimDetail.push({
                    index: index,
                    formDynamic: {
                        items: [
                            {
                                index: index,
                                status: 1,
                                claimValue: parseFloat(value.claim_value),
                                description: value.description,
                                categoryClaimId: value.category_claim ? value.category_claim.id : null,
                            }
                        ]
                    },
                });
            });

            this.isModalEdit = true;
        },
        showModalEditGroup: function (index) {
            let rowData = this.invoiceClaimGroupData[index];
            console.info('showModalEditGroup', rowData);
            let claimEdit = []
            rowData.claimListGroup.forEach(claim => {
                let detail = []
                claim.claim_detail.forEach(function (value, index) {
                    detail.push({
                        index: index,
                        status: 1,
                        claimValue: value.claim_value,
                        description: value.description,
                    });
                })

                let listClaim = {
                    claimGroupId: claim.claimId,
                    receivableId: claim.receivableId,
                    markingHeaderId: claim.markingHeaderId,
                    markingHeaderCode: claim.markingHeaderCode,
                    fileName: claim.fileName,
                    invoiceDateContainerCodeDescription: claim.invoiceDate
                        + ' - P. ' + claim.containerCode
                        + '\n¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯\n'
                        + claim.description,
                    claimValueTotal: claim.total_claim,
                    currency: claim.currency,
                    isSpecialMarking: claim.isSpecialMarking,
                    claimDetail: detail
                }

                claimEdit.push(listClaim)
            })
            this.formEditGroup = {
                claimId: rowData.claimId,
                claimLists: claimEdit
            }

            this.isModalGroupEdit = true;

        },
        postEdit: function () {
            this.isLoadingEdit = true;
            this.$Loading.start();

            let claimDetails = [];
            console.info('postEdit', this.formEdit, Number(this.claimValueTotal));
            _.forEach(this.formEdit.claimDetail, function (value, index) {
                if (value.formDynamic.items[0].status) {

                    let claim = {
                        claimValue: value.formDynamic.items[0].claimValue,
                        description: value.formDynamic.items[0].description,
                        categoryClaimId: value.formDynamic.items[0].categoryClaimId,
                    }

                    claimDetails.push(claim);
                }

            });

            let payload = {
                claimId: this.formEdit.claimId,
                receivableId: this.formEdit.receivableId,
                markingHeaderId: this.formEdit.markingHeaderId,
                totalClaim: parseFloat(this.claimValueTotal),
                claimDetails: claimDetails
            }

            HTTP
                .post('claim/update', payload)
                .then(response => {

                    this.isModalEdit = false;
                    this.isLoadingEdit = false;
                    this.$Loading.finish();
                    this.$Message.success('Claim updated !');

                    this.getClaimMarking()
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        postEditGroup: function () {
            // this.isLoadingEdit = true;
            // this.$Loading.start();
            let editClaim = this.formEditGroup
            let claimDetails = [];

            editClaim.claimLists.forEach(claim => {
                let details = []
                claim.claimDetail.forEach(detail => {

                    let obj = {
                        claimValue: detail.claimValue,
                        description: detail.description,
                    }

                    details.push(obj)
                })

                let objClaim = {
                    claimGroupId: claim.claimGroupId,
                    receivableId: claim.receivableId,
                    markingHeaderId: claim.markingHeaderId,
                    claimDetails: details
                }

                claimDetails.push(objClaim)
            })

            let payload = {
                claimId: editClaim.claimId,
                claimLists: claimDetails
            }

            HTTP
                .post('claimGroup/update', payload)
                .then(response => {

                    this.isModalGroupEdit = false;
                    this.isLoadingEdit = false;
                    this.$Loading.finish();
                    this.$Message.success('Claim Group updated !');

                    if (this.markingGroupIdSelected) {
                        this.getClaimMarkingGroup()
                    }
                })
                .catch(e => {
                    this.isModalGroupEdit = false;
                    this.isLoadingEdit = false;
                    this.$Loading.finish();
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })

        },
        handleBeforeUpload(file) {
            const isImage = file.type.startsWith('image/');

            if (!isImage) {
                this.$Message.error('Anda hanya dapat mengunggah file gambar!');
                return false;
            }
            const timestamp = Date.now();
            const extension = file.name.split('.').pop();
            const newFileName = `CLAIM-${timestamp}.${extension}`;
            const renamedFile = new File([file], newFileName, { type: file.type });

            const formData = new FormData();
            formData.append('file', renamedFile);
            formData.append('claimId', this.formUploadFile.claimId);
            formData.append('markingHeaderCode', this.formUploadFile.markingHeaderCode);

            this.isProgress = true;
            this.pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

            HTTP
                .post('/oss/claim-upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(response => {
                    this.formUploadFile.fileName = response.data.data.filename; // Set filename
                    this.formUploadFile.imageUploaded.push(response.data.data.file_url);
                    this.pValue = 100;
                    this.$Notice.success({ title: "File berhasil di upload !" });

                    if (this.isGroupFilter) {
                        this.getClaimMarkingGroup()
                    } else {
                        this.getClaimMarking()
                    }

                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },
        afterUploadFile: function () {
            this.formUploadFile.imageUploaded = []
            this.isProgress = false
            this.isModalUploadFile = false
        },
        updateFilter: function () {
            const fItemDeptId = this.itemDeptId
            const fBranchSelected = this.branchSelected
            const fDateKlaimSelect = this.dateKlaimSelect
            const fMarkingSelected = this.markingIdSelected
            const fCategorySelected = this.categoryId

            if(
              (fItemDeptId != '' && fItemDeptId != undefined)
              || (fBranchSelected != '' && fBranchSelected != undefined)
              || (fDateKlaimSelect[0] != '' && fDateKlaimSelect[0] != null)
              || (fMarkingSelected != '' && fMarkingSelected != undefined
              || (fCategorySelected != '' && fCategorySelected != undefined)
              )
            ) {
              this.isSearchShow = true
            }else {
              this.isSearchShow = false
            }
        },
        getBankAccount: function () {
            HTTP.get("bankAccount/findAll/active")
                .then(response => {
                    this.bankAccounts = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        changeClaimValue: function () {

            let claimTotal = 0;
            let currency = ''
            let isSpecialMarking = false

            this.formEditGroup.claimLists.forEach((value, index) => {
                let tempClaimTotal = 0;
                currency = value.currency
                isSpecialMarking = value.isSpecialMarking

                value.claimDetail.forEach((claim) => {
                    if (claim.status) {
                        tempClaimTotal += parseFloat(claim.claimValue);
                        claimTotal += parseFloat(claim.claimValue);
                    }
                });
                if (isSpecialMarking) {
                    value.claimValueTotal = tempClaimTotal != 0 ? currency + ". " + numeral(tempClaimTotal).format('0,0.00') : false;
                } else {
                    value.claimValueTotal = tempClaimTotal != 0 ? currency + ". " + numeral(tempClaimTotal).format('0,0') : false;
                }
            });
            if (isSpecialMarking) {
                this.formEditGroup.claimValueTotal = claimTotal != 0 ? currency + ". " + numeral(claimTotal).format('0,0.00') : false;
            } else {
                this.formEditGroup.claimValueTotal = claimTotal != 0 ? currency + ". " + numeral(claimTotal).format('0,0') : false;
            }
        },
        getUrlFile: function (Row) {
            let fileName = Row.file
            this.imageUrlFiles = []

            if (fileName.includes('~')) {
                let filenameToArray = fileName.split('~')

                filenameToArray.forEach(filename => {
                    HTTP.post('oss/claim-get-url', { file_name: filename })
                    .then(response => {

                        this.isModalImage = false;
                        this.isModalImageOss = true;
                        this.imageZoomLevel = 1;
                        this.imageUrlFiles.push(response.data.data.file_url);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                });
            } else {
                HTTP.post('oss/claim-get-url', { file_name: fileName })
                .then(response => {

                    this.isModalImage = false;
                    this.isModalImageOss = true;
                    this.imageZoomLevel = 1;
                    this.imageUrlFiles.push(response.data.data.file_url);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            }
        },
        showImage: function (raw) {

            let markingCode = raw.markingHeaderCode ? raw.markingHeaderCode : raw.markingGroupCode

            let payload = {
                markingHeaderCode: markingCode,
                filename: raw.file
            }

            HTTP
                .post('claim/file/download', payload, { responseType: 'blob' })
                .then(response => {

                    this.isModalImage = true;
                    this.isModalImageOss = false;
                    this.imageZoomLevel = 1;
                    this.imageUrl = window.URL.createObjectURL(response.data);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        zoomImage: function (type) {
            if (type == 'in' && this.imageZoomLevel < 5) {
                this.imageZoomLevel += 0.5
            } else if (type == 'out' && this.imageZoomLevel > 1) {
                this.imageZoomLevel -= 0.5
            } else if (type == 'reset') {
                this.imageZoomLevel = 1
            }
        },
        getBranchList: function () {
            let parent = this;
            HTTP
                .get('subbranch')
                .then(response => {
                    console.log({ response });
                    let branchList = []
                    _.forEach(response.data, function (value) {
                        let temp = {
                            value: value.subbranchcode,
                            label: value.subbranchname
                        }
                        branchList.push(temp);
                    });

                    parent.branchList = branchList;
                    console.info(parent.branchList);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        printClaimList: function () {
          console.log("HEY YA !");

          let startDateKlaim = null;
          let endDateKlaim = null;
          let markingIdSelected = null
          let itemDeptId = null
          let branch = null

          if (this.markingIdSelected != "") {
              markingIdSelected = this.markingIdSelected
          }

          if (this.dateKlaimSelect[0] != "" && this.dateKlaimSelect[0] != null) {
              startDateKlaim = moment(this.dateKlaimSelect[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
              endDateKlaim = moment(this.dateKlaimSelect[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }

          if (this.itemDeptId != "") {
              itemDeptId = this.itemDeptId
          }

          if (this.branchSelected != "") {
              branch = this.branchSelected
          }

          let payload = {
              markingHeaderId: markingIdSelected,
              startClaimDate: startDateKlaim,
              endClaimDate: endDateKlaim,
              itemDeptId: itemDeptId,
              branch: branch
          }

          // this.isPrintClaimList = true;
          HTTP.post('claim/print-to-excel', payload, {
            responseType: 'blob'
          })
            .then(response => {
              const blob = new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `KLAIM - ${moment(new Date()).format("DDMMYYhhmmss")}.xlsx`); // name file downloaded
              document.body.appendChild(link);
              link.click();
              link.remove();

              this.isPrintClaimList = false;
            })
        },
        getCategoryClaims: function() {
          HTTP.get("claim/categories")
          .then(response => {
            console.log({response});

            this.categoryClaims = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
        },
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        },
        currencyInter: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.00')
        }
    },
    mounted() {
        this.$Loading.config({
            color: '#ffffff',
            failedColor: '#f0ad4e',
            height: 10
        });

        if (this.markingIdSelected != '') {
            this.getClaimMarking()
        }

        this.getBankAccount();
        this.getBranchList();
        this.getCategoryClaims();
    },
    computed: {
        claimValueTotal: function () {
            let claimTotal = 0;
            let formEdit = this.formEdit
            _.forEach(formEdit.claimDetail, function (value, index) {
                if (value.formDynamic.items[0].status) {
                    claimTotal += parseFloat(value.formDynamic.items[0].claimValue);
                }
            });

            return claimTotal
        }
    }
}

</script>



// WEBPACK FOOTER //
// ClaimList.vue?385137d8